'use client';
import React, { useState, useEffect } from 'react';
import BenefitItem from '../benefitIcons/BenefitItem';
import WindowSize from '@/utils/windowSize';

export default function CompanyUSP({ block, position }) {
  const windowSize = WindowSize();
  const [showDesktop, setShowDesktop] = useState(false);
  const pageUsp = block?.company_usp?.reference?.[0];
  const source = pageUsp?.title ? pageUsp : block?.company_usp?.company_usp;
  const { item, title, background_color_picker } = source ?? {};
  const { uid } = block.company_usp._metadata;

  useEffect(() => {
    setShowDesktop(windowSize.width > 1199);
  }, [windowSize]);

  if (!item?.length) return null;

  return (
    <section
      id={`${uid}_${position}`}
      data-name={'company-usp'}
      className={`company-usp bg-[${background_color_picker}] standard-padding min-h-[172px]`}
    >
      {title && (
        <h2 className="h5 sm:h2 mb-5 px-4 text-center lg:mb-10">{title}</h2>
      )}
      <ul className="flex items-stretch justify-center">
        {item?.map((item, index) => (
          <li
            key={index}
            className="relative flex w-[300px] grow cursor-pointer flex-col items-stretch justify-center rounded-sm text-center 2xl:grow-0"
          >
            <BenefitIconItem
              key={index}
              index={index}
              item={item}
              size={showDesktop ? 'large' : 'small'}
              collection={true}
            />
          </li>
        ))}
      </ul>
    </section>
  );
}

function BenefitIconItem({
  index,
  item,
  size,
  productModal = false,
  collection = false
}) {
  return (
    <BenefitItem
      index={index}
      icon={item.icon}
      modalIcon={item.icon}
      title={item.title}
      description={item.description}
      size={size}
      productModal={productModal}
      collection={collection}
    />
  );
}
